import { useQueryClient } from "@tanstack/react-query"

import { invalidateDocumentProject, invalidateDocumentsList } from "@l2r-front/l2r-app-doc"
import { useNetworksStateContext } from "@l2r-front/l2r-networks"
import { l2rApiAxiosInstance as axiosInstance } from "@l2r-front/l2r-query"

import { equipmentQueryKeys } from "../queries/equipment/queryKeys"

import { useEquipmentMutation } from "./useEquipmentMutation"

export function useEquipmentDelete(
    equipmentId,
    config = {},
) {
    const url = `equipments/${equipmentId}/`
    const queryClient = useQueryClient()
    const { selectedNetwork } = useNetworksStateContext()

    return useEquipmentMutation(
        url,
        axiosInstance.delete,
        {},
        {
            ...config,
            onSuccess: (data) => {
                queryClient.invalidateQueries({ queryKey: equipmentQueryKeys.project() })
                queryClient.invalidateQueries({ queryKey: equipmentQueryKeys.layer() })
                queryClient.invalidateQueries({ queryKey: equipmentQueryKeys.stats_categories() })
                queryClient.invalidateQueries({ queryKey: equipmentQueryKeys.stats_conditions() })
                invalidateDocumentProject(queryClient, selectedNetwork)
                invalidateDocumentsList(queryClient, selectedNetwork)

                config.onSuccess?.(data)
            },
        },
    )
}